import type { PricedPackageItem, PricedProduct, VpeLine } from './types';

export interface VpeInput {
  quantity_per_package: number;
  total_packages: number;
  vpe: number;
  unit_purchase_price: number;
}

export interface VpeOutput {
  qty_needed_raw: number;
  vpe_units_needed: number;
  total_ordered: number;
  leftover_units: number;
  total_purchase_cost: number;
  leftover_value: number;
}

export function calcVpeLine({
  quantity_per_package,
  total_packages,
  vpe,
  unit_purchase_price,
}: VpeInput): VpeOutput {
  if (vpe <= 0) {
    throw new Error('vpe must be > 0');
  }
  const qtyNeededRaw = quantity_per_package * total_packages;
  const vpeUnitsNeeded = Math.ceil(qtyNeededRaw / vpe);
  const totalOrdered = vpeUnitsNeeded * vpe;
  const leftoverUnits = totalOrdered - qtyNeededRaw;
  const totalPurchaseCost = totalOrdered * unit_purchase_price;
  const leftoverValue = leftoverUnits * unit_purchase_price;
  return {
    qty_needed_raw: qtyNeededRaw,
    vpe_units_needed: vpeUnitsNeeded,
    total_ordered: totalOrdered,
    leftover_units: leftoverUnits,
    total_purchase_cost: totalPurchaseCost,
    leftover_value: leftoverValue,
  };
}

export function calculateVPELines<TProduct extends PricedProduct = PricedProduct>(
  items: PricedPackageItem[],
  totalPackages: number
): VpeLine<TProduct>[] {
  return items
    .filter((item): item is PricedPackageItem & { gift_product: TProduct } =>
      Boolean(item.gift_product)
    )
    .map((item) => {
      const product = item.gift_product;
      const out = calcVpeLine({
        quantity_per_package: item.quantity_per_package,
        total_packages: totalPackages,
        vpe: product.vpe,
        unit_purchase_price: product.unit_purchase_price,
      });
      return {
        product,
        quantity_per_package: item.quantity_per_package,
        unit_purchase_price: product.unit_purchase_price,
        ...out,
      };
    });
}
